import { render, staticRenderFns } from "./CoreTableRow.vue?vue&type=template&id=36f04c62&scoped=true&lang=pug&"
import script from "./CoreTableRow.vue?vue&type=script&lang=js&"
export * from "./CoreTableRow.vue?vue&type=script&lang=js&"
import style0 from "./CoreTableRow.vue?vue&type=style&index=0&id=36f04c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f04c62",
  null
  
)

export default component.exports